import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeGql } from '../../bimWorkOrderChangeQueries';

export const useBimWorkOrderChange = (workOrderChangeId: number) => {
    const dispatch = useDispatch();
    const variables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [bimWorkOrderChangeData, bimWorkOrderChangeStatus, , bimWorkOrderChangeRequest] = useRequest({
        requestId: `bimWorkOrderChange${workOrderChangeId}`,
        query: bimWorkOrderChangeGql,
        withEffect: !!workOrderChangeId,
        variables,
    });

    const refreshWorkOrderChangeData = useCallback(() => {
        dispatch(bimWorkOrderChangeRequest(variables));
    }, [dispatch, variables, bimWorkOrderChangeRequest]);

    return {
        workOrderChangeData: bimWorkOrderChangeData?.bimWorkOrderChange?.data,
        bimWorkOrderChangeStatus,
        refreshWorkOrderChangeData,
    };
};
